import type { TPermissionLevel } from '@op/services/report';

export const PERMISSION_LEVEL_OPTIONS: Array<{
  value: TPermissionLevel;
  iconType: string;
  titleKey: string;
  descKey: string;
}> = [
  {
    value: 'private',
    iconType: 'lock-circle',
    titleKey: 'Only Me',
    descKey: 'Only you can view this report',
  },
  {
    value: 'partial',
    iconType: 'persons',
    titleKey: 'Selected Users',
    descKey: 'Selected users can view this report in AI Task Center',
  },
  {
    value: 'public',
    iconType: 'net-work',
    titleKey: 'Everyone',
    descKey: 'The report will be displayed on the AI Insights Report page',
  },
];

export const PERMISSION_LEVEL_ICON: Record<'private' | 'public', string> = {
  private: 'lock-circle',
  public: 'net-work',
};

export const MAX_AVATAR_STACK = 3;
export const VISIBLE_AVATAR_COUNT = 2;

export type TReportOwner = 'all' | 'mine' | 'shared';

export const DEFAULT_REPORT_OWNER: TReportOwner = 'mine';

export const SAVED_LIST_DEFAULT_REPORT_OWNER: TReportOwner = 'all';

export function parseReportOwnerQuery(
  value?: string | string[],
): TReportOwner | undefined {
  const owner = Array.isArray(value) ? value[0] : value;
  if (owner === 'all' || owner === 'mine' || owner === 'shared') {
    return owner;
  }
  return undefined;
}

export function buildSavedAnalysisListUrl(
  baseUrl: string,
  owner?: TReportOwner,
): string {
  if (!owner || owner === SAVED_LIST_DEFAULT_REPORT_OWNER) {
    return `${baseUrl}?tab=savedAnalysisList`;
  }
  return `${baseUrl}?tab=savedAnalysisList&owner=${owner}`;
}
